var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.657 24.131c-.126.722.585 1.286 1.213.964l7.133-3.666 7.132 3.666c.628.322 1.34-.242 1.213-.962l-1.35-7.686 5.724-5.454c.536-.51.26-1.443-.458-1.544l-7.96-1.13-3.548-7.032a.833.833 0 0 0-1.507 0L8.7 8.32.741 9.451c-.717.1-.994 1.034-.46 1.544l5.725 5.453-1.349 7.686v-.003Zm7.97-4.496-5.989 3.078 1.128-6.43a.918.918 0 0 0-.265-.821L2.779 10.96l6.584-.936a.853.853 0 0 0 .639-.468L13 3.612l3.001 5.945a.853.853 0 0 0 .639.468l6.584.934-4.722 4.501a.917.917 0 0 0-.265.822l1.128 6.43-5.99-3.077a.818.818 0 0 0-.749 0h.002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.14e3697555e821c2ab1a12d7091ba3ac.svg";
export { ForwardRef as ReactComponent };